// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2WigM","footer":"ChangeClinic_footer__1h1VC"};